import { __decorate } from "tslib";
import isString from 'lodash-es/isString';
import isBoolean from 'lodash-es/isBoolean';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import { Options as Component, Vue } from 'vue-property-decorator';
// import attributes from '../store/attributes.mjs';
let FormMixin = class FormMixin extends Vue {
    format;
    nestedModel(field, item) {
        let attribute = field.attribute;
        if (!item && field.targetAttribute) {
            const values = field.values || [field];
            attribute = field.targetAttribute;
            item = values.find((x) => x.attribute === field.targetAttribute);
        }
        return { attribute, item };
    }
    // Render and aux
    emptyFieldMessage(field) {
        return (field && field.emptyMsg) || 'N/A';
    }
    getAttributesTextGlobal(field, currentModel, nestedModel) {
        let value = currentModel[field.attribute];
        if (field.type === 'chips' && !field.multiple) {
            value = value ? value[0] : value;
        }
        // TODO: I18N
        if (value === undefined) {
            const text = this.emptyFieldMessage(field);
            return text;
        }
        if (Array.isArray(value)) {
            let operatorText = '';
            if (field.operators && value.length > 1 && nestedModel) {
                operatorText = nestedModel[field.operators_attribute] ? 'All of: ' : 'Any of: ';
            }
            return (operatorText +
                value
                    .map((v, index) => {
                    const name = v && (v.name || v.full_name);
                    if (name) {
                        // keep values that are all uppercased(acronyms)
                        if (name.match(/^[A-Z1-9\s\(\)]+$/)) {
                            return name;
                        }
                        return value.length > 1 && index > 0 ? name.toLowerCase() : name;
                    }
                    return undefined;
                })
                    .filter((v) => v !== undefined)
                    .join(', ') || this.emptyFieldMessage(field));
        }
        if (isBoolean(value)) {
            return value ? 'Yes' : 'No';
        }
        let timestamp = 1292051460;
        if (isNumber(value) && value >= timestamp) {
            return this.format.datetime(value);
        }
        if (value && value.nested && value.nested[0] && nestedModel) {
            const fieldNested = value.nested[0];
            const nestedAttribute = fieldNested.attribute;
            let nestedValue = nestedModel[nestedAttribute] || currentModel[nestedAttribute];
            if (fieldNested.type === 'selector' && fieldNested.values) {
                nestedValue = fieldNested.values.find((v) => v.value === nestedValue);
            }
            if (fieldNested.type === 'location') {
                if (Array.isArray(nestedValue)) {
                    return nestedValue.map((v) => (isObject(v) ? v.full_name : v)).join(', ');
                }
                return 'expand';
            }
            let nestedText = (nestedValue && nestedValue.name) ||
                (fieldNested.type === 'unitInput' && this.unitsToText(fieldNested, nestedValue)) ||
                nestedValue;
            if (isString(nestedText)) {
                if (nestedText === 'COVID-19 efforts') {
                    nestedText = 'Zero Budget • COVID-19 efforts';
                }
                return nestedText;
            }
        }
        if (field.type === 'unitInput') {
            return this.unitsToText(field, value);
        }
        return (value && value.name) || value;
    }
    unitsToText(field, model) {
        const v = model?.value;
        const isEmpty = ((!v || (!v.length && isNaN(Number(v)))) && !model?.form && !model?.until) ||
            (model?.currency && !field.currencies.values);
        if (isEmpty) {
            return '';
        }
        const modelCurrency = model.currency && field.currencies.values.find((x) => x.id === model.currency);
        const unit = model.unit || '';
        if (modelCurrency && this.format) {
            const formattedPrice = field.range && model.from && model.until
                ? `${this.format.vdlCurrencyFormatter(model.from, modelCurrency)} to ${this.format.vdlCurrencyFormatter(model.until, modelCurrency)}`
                : `${this.format.vdlCurrencyFormatter(model.value, modelCurrency)}`;
            const currency = (Object.keys(modelCurrency).length > 0 &&
                `${modelCurrency.code}${modelCurrency.custom_data.sign ? modelCurrency.custom_data.sign : ''}`) ||
                '';
            if (field.textFormat && typeof field.textFormat === 'function') {
                return field.textFormat({
                    ...model,
                    formattedPrice,
                    currency,
                });
            }
            return field.prefix ? `${unit} ${formattedPrice}` : `${formattedPrice} ${unit}`;
        }
        const unitModel = field.units && field.units.find((u) => u.value === unit);
        const value = Number(model.value);
        // TODO: Find a better way of managing pluralization I18N.
        // Tried this.format.unit, but having issues with non-standard units: pages, words
        return value === 1 && unitModel && unitModel.singular ? `${value} ${unitModel.singular}` : `${model.value} ${unit}`;
    }
};
FormMixin = __decorate([
    Component({})
], FormMixin);
export default FormMixin;
//# sourceMappingURL=FormMixin.mjs.map